import React, { useState } from "react";
import "./style.css";
import Modal from "../Modal";

type PaymentCheckBoxProps = {
  title: string;
  setCheck: (value: boolean) => void;
  check: boolean;
  link?: boolean;
};

const PaymentCheckBox: React.FC<PaymentCheckBoxProps> = ({
  link,
  title,
  setCheck,
  check,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const openModal = () => {
    if (!check) {
      setModalOpen(true);
      document.body.classList.add("modal-open");
    }
  };

  return (
    <div className="saveCard">
      <input
        type="checkbox"
        id="save"
        className={!check ? "input" : "activeInput"}
        onChange={() => setCheck(!check)}
        onClick={openModal}
        checked={check}
        data-track="save-card-checkbox"
      />
      <div
        className="saveCardText"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      ></div>
      {modalOpen && <Modal close={setModalOpen} check={setCheck} />}
    </div>
  );
};

export default PaymentCheckBox;
